import { useEffect, useState } from 'react'
import { parseCookies } from 'nookies'
import { useSessionContext } from '@contexts/session'
import getConfig from 'next/config'
import { AWS_ACCESS_KEY_ID, AWS_ENDPOINT } from '@lib/constants/common'
import { MAX_FILE_SIZE } from '@lib/constants/competitions'
import 'react-fine-uploader/gallery/gallery.css'

type Props = {
  fieldName: string
  error?: string
}

const { serverRuntimeConfig, publicRuntimeConfig } = getConfig()

const endpoint = serverRuntimeConfig.SSR_API_ENDPOINT
  ? serverRuntimeConfig.SSR_API_ENDPOINT
  : publicRuntimeConfig.CSR_API_ENDPOINT

let Gallery
let uploader
export const S3FileUploader = ({ fieldName, error }: Props): JSX.Element => {
  const [rerenderFlag, setRerenderFlag] = useState(false)
  const { id: userId } = useSessionContext()
  const token = parseCookies().token

  useEffect(() => {
    setS3FileUploaderConifg()
  }, [])

  const getUploadedFileName = (containerId) => {
    const elem: HTMLElement = document.querySelector(
      `#${containerId} .react-fine-uploader-filename`
    )
    const filename = elem.innerText
    const folderName = `media/userdata/${userId}/`
    const completeFilePath = folderName + filename

    return completeFilePath
  }

  const setS3FileUploaderConifg = async () => {
    const FineUploaderS3 = (await import('fine-uploader-wrappers/s3')).default
    Gallery = (await import('react-fine-uploader')).default
    uploader = new FineUploaderS3({
      options: {
        request: {
          endpoint: AWS_ENDPOINT,
          accessKey: AWS_ACCESS_KEY_ID, // same os os.environ["AWS_ACCESS_KEY_ID"]
        },
        signature: {
          version: 4,
          endpoint: endpoint + '/api/v1/fine-uploader/', // signature url endpoint
          customHeaders: {
            Authorization: `Token ${token}`,
          },
        },
        cors: {
          expected: true,
        },
        chunking: {
          enabled: false,
        },
        resume: {
          enabled: false,
        },
        deleteFile: {
          enabled: false,
        },
        validation: {
          itemLimit: 1,
          sizeLimit: MAX_FILE_SIZE,
        },
        objectProperties: {
          acl: 'public-read',
          region: 'ap-south-1',
          key: function () {
            return getUploadedFileName(fieldName)
          },
        },
      },
    })

    setRerenderFlag(!rerenderFlag)
  }

  return (
    <>
      <div id={fieldName}>
        {uploader && <Gallery uploader={uploader} />}
        <div className="my-2">
          {error && (
            <div className="text-sm leading-4 text-red-200 font-400">
              {error}
            </div>
          )}
        </div>
      </div>
    </>
  )
}
